export default "__VITE_ASSET__BApI0ddg__"